import React from "react"
import PropTypes from "prop-types"
import RaisedButton from "material-ui/RaisedButton"

import TextField from "material-ui/TextField"
import FlatButton from "material-ui/FlatButton"
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton"
import StateSelectField from "../../../../components/misc/StateSelectField"
import AuthorizationDocSelectField from "./AuthorizationDocSelectField"
import GovernmentDocInfo from "./GovernmentDocInfo"

const propTypes = {
    i9: PropTypes.object
}

export default class AuthorizeToWork extends React.Component {
    constructor(props, context) {
        super(props, context)
        this.state = {
            quickSelection: -1
        }
        this.onChange = this.onChange.bind(this)
        this.onAuthorizeToWorkDocInfoChange = this.onAuthorizeToWorkDocInfoChange.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.i9) {
            const _this = this

            this.setState({
                i9: nextProps.i9
            })
        }
    }

    componentDidMount() {}

    getState() {}

    onStateChange() {}

    onChange(event, value) {
        this.setState({
            quickSelection: value
        })
    }

    onAuthorizeToWorkDocInfoChange(docInfo) {}

    render() {
        return (
            <div className="AuthorizeToWork">
                <p>
                    <b>Employee Authorization To Work Document</b>
                </p>
                <table>
                    <tbody>
                        <tr>
                            <td>
                                <div>
                                    <p>Choose an employee supplied document that establishes an employee's authorization to work:</p>
                                    <RadioButtonGroup name="quickSelectIdentity" onChange={this.onChange} valueSelected={this.state.quickSelection}>
                                        <RadioButton value={0} label="Social Security Account Number Card" />
                                        <RadioButton value={1} label="Birth Certificate" />
                                        <RadioButton value={2} label="U.S. Citizen ID Card" />
                                        <RadioButton value={3} label="Other" />
                                    </RadioButtonGroup>
                                    {this.state.quickSelection === 3 && (
                                        <div>
                                            <AuthorizationDocSelectField />
                                        </div>
                                    )}
                                </div>
                            </td>
                            <td>
                                <GovernmentDocInfo onChange={this.onAuthorizeToWorkDocInfoChange} />
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        )
    }
}

AuthorizeToWork.propTypes = propTypes
